import React, { useEffect } from 'react'

import { useAuth } from 'src/modules/auth'
import { useActionRunner } from 'src/modules/notification'

import { usePurchasing } from '../hooks'
import DraftOrder from './DraftOrder'

const DraftOrderView = ({ match }) => {
  const { hasPermission } = useAuth()
  const { fetchDraftOrder, draftOrder, purchasingEnvironment } = usePurchasing()
  const [doFetchDraftOrder, isFetching] = useActionRunner(fetchDraftOrder, {
    initialFetchingState: true,
  })
  const { id } = match.params
  console.log('draft order view', draftOrder)
  useEffect(() => {
    doFetchDraftOrder({ id, environmentId: purchasingEnvironment })
  }, [id])

  if (isFetching || !draftOrder) {
    return null
  }

  if (!isFetching && !draftOrder) {
    console.log('Draft order not found')
  }

  return (
    <DraftOrder canSubmit={hasPermission('submit_orders')} {...draftOrder} />
  )
}

export default DraftOrderView
